import { render, staticRenderFns } from "./TripSidebarContent.vue?vue&type=template&id=de3bb88c"
import script from "./TripSidebarContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripSidebarContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports